import { useEffect, useRef, useState } from 'preact/hooks';
import style from './Tooltip.css';
import { renderIf } from '../../../utils/render.utils';
import { _className } from '../../../utils/classname.utils';

const TooltipPosition = { TOP: 'top', BOTTOM: 'bottom' };
export default function Tooltip({
  content,
  delay = 0,
  children,
  position = TooltipPosition.BOTTOM,
  showing = false,
}) {
  const [showTooltip, setShowTooltip] = useState(showing);
  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });
  const [arrowPosition, setArrowPosition] = useState({ left: 0, top: 0 });
  let timeout;
  const ref = useRef();

  const handleMouseEnter = event => {
    setShowTooltip(true);
    timeout = setTimeout(() => {
      const { top, left, width, height } = event.target.getBoundingClientRect();
      const tooltipWidth = ref.current?.offsetWidth;

      const availableSpaceLeft = left - tooltipWidth / 2;
      const availableSpaceRight =
        window.innerWidth - (left + width + tooltipWidth / 2);

      let tooltipLeft;
      if (availableSpaceLeft < 10) {
        tooltipLeft = 10;
      } else if (availableSpaceRight < 10) {
        tooltipLeft = window.innerWidth - tooltipWidth - 10;
      } else {
        tooltipLeft = left + width / 2 - tooltipWidth / 2;
      }

      let tooltipTop = 0;

      if (position === TooltipPosition.TOP) {
        tooltipTop = window.scrollY + (top - ref.current.offsetHeight - 10);
        setArrowPosition({
          left: left + width / 2,
          top: tooltipTop + ref.current.offsetHeight,
        });
      } else {
        tooltipTop = top + window.scrollY + height + 10;
        setArrowPosition({ left: left + width / 2, top: tooltipTop - 12 });
      }

      setTooltipPosition({ top: tooltipTop, left: tooltipLeft });
    }, delay);
  };

  const handleMouseLeave = () => {
    clearTimeout(timeout);
    setShowTooltip(false);
  };

  useEffect(() => {
    if (!ref.current) return;

    if (showing) {
      const { top, left, width, height } = ref.current.getBoundingClientRect();
      const tooltipLeft = 10;
      const tooltipTop = top + window.scrollY + height + 10;

      setTooltipPosition({ top: tooltipTop, left: tooltipLeft });
      setArrowPosition({ left: left + width / 2, top: tooltipTop - 12 });
    }
  }, [children]);

  return (
    <div
      className={`${style['tooltip-wrapper']} ${style[position]} ${_className(
        showTooltip,
        style.showing,
      )}`}
      onMouseEnter={showing ? handleMouseLeave : handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      ref={ref}
    >
      {children}
      {renderIf(
        showTooltip,
        <>
          <div
            className={style['tooltip-tip']}
            style={{
              ...tooltipPosition,
              transition: `opacity ${delay}ms ease-in-out`,
            }}
            ref={ref}
          >
            {content}
          </div>
          <div
            className={style.arrow}
            style={{
              ...arrowPosition,
              transition: `opacity ${delay}ms ease-in-out`,
            }}
          ></div>
        </>,
      )}
    </div>
  );
}

Tooltip.Position = TooltipPosition;
